// Minimum social tracking, removing native popup social sharing behaviours due to Omniture/Chrome popup blocking bugs
// For now track via Google Analytics _trackSocial functions, and investigate restoring links as part of v1.1

// Facebook 
$('#social .facebook, .social .facebook a').click(function() {
GA.trackSocial('facebook', 'share');
});

// Twitter
$('#social .twitter, .social .twitter a').click(function() {
GA.trackSocial('twitter', 'tweet');
});

// Pinterest
$('#social .pinterest, .social .pinterest a').click(function() {
GA.trackSocial('pinterest', 'pin');
});
